export const weekInMillis = 604800000;
export const secondInMillis = 1000;
